import { Button, Loading } from "@/components";
import { useDate, useStatusModeState } from "@/shared/client";
import { BookingStatusResponse, useGetBookingStatus } from "@/shared/server";
import theme from "@/styles/theme";
import { Box, Center } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { Dates, Days, ReservationStatusBox } from "./components";
import { YearMonth } from "./components/yearMonth";

export const BookCalendar = () => {
    const { date, setDate } = useDate();
    const [statusMode, setStatusMode] = useStatusModeState();

    const { data } = useGetBookingStatus<BookingStatusResponse>({
        year: String(date.getFullYear()),
        month: String(date.getMonth() + 1).padStart(2, "0"),
    });

    return (
        <Center width="100%" gap={8} flexDir="column">
            <YearMonth date={date} setDate={setDate} />
            <Center margin="35px 0" width="100%" position="relative">
                <ReservationStatusBox />
                <Box position="absolute" right="0">
                    <CustomButton
                        size="medium"
                        round="none"
                        iconNamed="change_circle"
                        isLookPrice={statusMode === "status"}
                        onClick={() =>
                            setStatusMode((prev) => {
                                if (prev === "status") return "price";
                                if (prev === "price") return "status";
                                return prev;
                            })
                        }
                    >
                        요금보기
                    </CustomButton>
                </Box>
            </Center>
            {data ? (
                <Center
                    width="100%"
                    flexDir="column"
                    border={`1px solid ${theme.COLOR.gray[300]}`}
                    borderRadius="16px"
                    overflow="hidden"
                >
                    <Days />
                    <Dates date={date} statusData={data.result} endDate={data.endDate} />
                </Center>
            ) : (
                <Loading h="640px" spinnerSize="xl">
                    숙소 정보를 불러오고 있습니다...
                </Loading>
            )}
        </Center>
    );
};

export const CustomButton = styled(Button)<{ isLookPrice: boolean }>`
    width: 108px;
    padding: 0;
    transition: 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    color: ${({ isLookPrice, theme }) => (isLookPrice ? theme.COLOR.black : theme.COLOR.white)};
    background: ${({ isLookPrice, theme }) => (isLookPrice ? theme.COLOR.white : theme.COLOR.pink[200])};
    border: ${({ isLookPrice }) => (isLookPrice ? `1px solid ${theme.COLOR.gray[400]}` : "none")} !important;
`;
